<script>
export default {
  name: 'NoSearchResultFound',
  emits: ['resetSearch'],
}
</script>

<template>
  <div class="empty-block">
    <div class="content">
      <h1>{{ $t('noSearchBookings.noBookingLable') }}</h1>
      <p>{{ $t('noSearchBookings.noBookingParagraph') }}</p>

      <div class="button">
        <BaseButton
          outlined
          light
          color="black"
          text-color="black"
          class="classButton me-5"
          @click="$emit('resetSearch')"
        >
          {{ $t('noSearchBookings.clearSearch') }}
        </BaseButton>
        <BaseButton class="allSearchButton p-5" @click="$emit('resetSearch')">
          {{ $t('noSearchBookings.searchAllBookings') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/no-booking-found.scss';
</style>
